import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import { formatCurrency, formatUSDateString } from '@/classes/Helpers'

export interface nutritionTransaction {
  transactionId: number
  districtId: number
  TsId: number
  lineId: number
  menuitemId: number
  amount: number
  isFee: boolean
  itemName: string
  purchaseDate: string
  studentName: string
  healthEProId: number | null
  healthEProOrgId: number | null
  studentHidden: boolean | null
  studentHiddenLocked: boolean | null
  transId: number | null
  mealType: string | null
}

// GET /ajax/nutrition_transactions/
export const nutritionTransactions = async (
  familyAccountId: string | null = null,
  studentAccountId: string | null = null,
  days: number = 30,
  startDate: Date | null = null,
  endDate: Date | null = null
) => {
  // Format dates to Y-m-d format if they exist
  const formattedStartDate = startDate ? startDate.toISOString().split('T')[0] : null
  const formattedEndDate = endDate ? endDate.toISOString().split('T')[0] : null

  const params = {
    family_account_id: familyAccountId,
    student_account_id: studentAccountId,
    days: days,
    start_date: formattedStartDate,
    end_date: formattedEndDate
  }
  const response = await new Request().get('/ajax/nutrition_transactions/', params)

  // Check if transactions exists and is an array
  if (!response.data || !response.data.transactions) {
    console.error('No transactions data found in response')
    return []
  }

  if (!Array.isArray(response.data.transactions)) {
    console.error('Transactions is not an array:', response.data.transactions)
    return []
  }

  // Format the transactions before returning them
  const formattedTransactions = response.data.transactions.map((transaction: any) => {
    try {
      transaction = Util.Obj.keysToCamel(transaction)

      // Check if the field names match what we expect
      const formattedTransaction = {
        ...transaction,
        // Handle potential field name mismatches
        itemName: transaction.itemName || transaction.menuitemDescription || '',
        isFee: transaction.isFee ? 'Yes' : 'No',
        amount: formatCurrency(+transaction.amount),
        purchaseDate: formatUSDateString(transaction.purchaseDate)
      }

      return formattedTransaction
    } catch (error) {
      console.error('Error formatting transaction:', error, transaction)
      // Return the original transaction if formatting fails
      return transaction
    }
  })

  return formattedTransactions as nutritionTransaction[]
}
